import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TypedActivatedRoute } from '@assetaccountant/core/utils/route-utils';

import { AuthenticationService } from '../../../core/services/authentication.service';
import { QuickBooksService } from '../../services/quickbooks.service';

@Component({
  selector: 'app-quickbooks-connect-realm',
  templateUrl: './quickbooks-connect-realm.component.html',
  styleUrls: ['./quickbooks-connect-realm.component.scss'],
  standalone: false,
})
export class QuickBooksConnectRealmComponent implements OnInit {
  get title() {
    return { pageTitle: 'QuickBooks Connect' };
  }

  constructor(
    @Inject(ActivatedRoute)
    private route: TypedActivatedRoute<{}, {}, { isRelog?: boolean }>,
    private authService: AuthenticationService,
    private quickBooksService: QuickBooksService,
  ) {}

  async ngOnInit() {
    const returnUrl = new URL(location.href);

    if (!returnUrl.searchParams.has('isRelog')) {
      returnUrl.searchParams.append('isRelog', 'true');
    }

    // If the user is not authenticated, we need to authenticate them with the external identity provider.
    if (!this.authService.isAuthenticated()) {
      this.authService.init(returnUrl.toString(), { acr_values: 'idp:Intuit' });
      return;
    }

    // Ensure the user is authenticated with the correct identity provider.
    if (!this.route.snapshot.queryParams.isRelog) {
      this.authService.logOut(returnUrl.toString());
      return;
    }

    this.quickBooksService.initiateOAuth(location.href);
  }
}
